import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [isDark, setIsDark] = useState(() => {
        try {
            const stored = localStorage.getItem('insights_theme');
            if (stored) return stored === 'dark';
        } catch (_) {}
        return true; // Default to dark mode or based on preference
    });

    useEffect(() => {
        const theme = isDark ? 'dark' : 'light';
        try {
            localStorage.setItem('insights_theme', theme);
        } catch (_) {}
        // Apply to html element for global overrides
        document.documentElement.setAttribute('data-theme', theme);
    }, [isDark]);

    const toggleTheme = useCallback(() => {
        setIsDark(prev => !prev);
    }, []);

    return (
        <ThemeContext.Provider value={{ isDark, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const ctx = useContext(ThemeContext);
    if (!ctx) throw new Error('useTheme must be used within a ThemeProvider');
    return ctx;
};
